import { getTableColumns } from 'helpers';

const PIOVerColumns = [
  ['pioChangeNumber', 'number', 'PIO #', 'center', true],
  ['pioChangeType', 'string', 'Change Type', 'left', true],
  ['localChangeNumber', 'string', 'Local Change #', 'left', true],
  ['localDate', 'date', 'Local Date', 'center', true],
  ['pioVersionDate', 'date', 'Receipt Date', 'center', true],
  ['pioVersionStatus', 'string', 'Status', 'left', true],
  ['pioVersionStatusDate', 'date', 'Status Date', 'left', true]
];


export default getTableColumns(PIOVerColumns);
